"use client";;
import { useSessionStorage } from "@/app/hooks/useLocalStorage";
import { refreshUserToken } from "@/lib/actions/auth.action";
import { signOut, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { toast } from "sonner";
//TODO: change to refresh token logic

/** handler session state such as refreshToken / userNotOnServer(discord)  */
export default function SessionHandler() {
    const session = useSession();
    const router = useRouter()
    /** indicates if the user refreshed token on any tab on this current session */
    const [isSession_RefreshedToken, setIsSession_RefreshedToken] = useSessionStorage("refreshingToken", false)

    useEffect(() => {
        const refreshTokenNeeded = session.data?.user.refreshTokenNeeded;
        if (!refreshTokenNeeded) //if no need in refresh - exit
            return;

        //if currently other browser instance already refreshed - exit
        if (isSession_RefreshedToken)
            return;

        console.log("תוקן משתמש ישן מידי - מתחיל תהליך רענון...")
        //block from other browser tabs
        setIsSession_RefreshedToken(true);
        refreshUserToken() //start refresh logic
            .then(async () => {
                console.log("תוקן רוענן בהצלחה.")
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.data?.user.refreshTokenNeeded])

    //when page loaded (e.g. on client side render)
    useEffect(() => {
        //handle state where user is left discord server while logged in to the site
        const notOnServer = session?.data?.user?.userNotOnServer == true
        if (notOnServer) {
            toast.info("בשביל להתחבר לאתר יש להיכנס לשרת דיסקורד של נייטפול")
            signOut({ "redirect": false });
            router.push(`/login?error=NotOnDiscord`)

        }
    }, [router, session?.data])
    return <></>
}
